import { render, staticRenderFns } from "./EndorsementsUnapproved.vue?vue&type=template&id=11cf8462&scoped=true&"
import script from "./EndorsementsUnapproved.vue?vue&type=script&lang=js&"
export * from "./EndorsementsUnapproved.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementsUnapproved.vue?vue&type=style&index=0&id=11cf8462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cf8462",
  null
  
)

export default component.exports